import React, { useState, useEffect, useRef } from 'react';
import './GeneratePrompt.css';

const GeneratePrompt = ({ onSubmit }) => {
  const [prompt, setPrompt] = useState('');
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [showCursor, setShowCursor] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const isInside = 
          e.clientX >= rect.left && 
          e.clientX <= rect.right && 
          e.clientY >= rect.top && 
          e.clientY <= rect.bottom;
        
        setShowCursor(!isInside);
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    return () => document.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!prompt.trim()) {
      setError('Please describe your project');
      return;
    }

    if (!email.trim()) {
      setError('Please enter your email');
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      await onSubmit({ prompt, email });
    } catch (err) {
      setError('Failed to submit. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleMouseMove = (e) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const rotateY = ((x / rect.width) - 0.5) * 10;
    const rotateX = ((y / rect.height) - 0.5) * -10;
    card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
  };

  const resetTransform = (e) => {
    e.currentTarget.style.transform = '';
  };

  return (
    <div className="prompt-container" ref={containerRef}>
      <div
        className="prompt-card"
        onMouseMove={handleMouseMove}
        onMouseLeave={resetTransform}
      >
        <div className="prompt-icon-blue">
          <svg viewBox="0 0 100 100"  xmlns="http://www.w3.org/2000/svg">
            <path d="M84.0673 0.0229201L15.8021 0.112156C7.07485 0.123564 0.00924821 7.20767 0.0206565 15.9349L0.109892 84.2001C0.121301 92.9274 7.2054 99.993 15.9327 99.9816L84.1979 99.8924C92.9251 99.881 99.9907 92.7969 99.9793 84.0696L99.8901 15.8044C99.8787 7.07712 92.7946 0.0115119 84.0673 0.0229201Z" fill="#4285F4" />
            <path d="M60.2807 78.9233L55.2424 78.9299C54.6773 78.9306 54.221 78.4721 54.2202 77.9104L54.2065 67.3874C54.2057 66.8225 54.6642 66.366 55.226 66.3653L59.2203 66.36C60.0397 66.359 60.7264 66.0707 61.3171 65.4817C61.9043 64.8928 62.1909 64.103 62.1896 63.0687L62.1789 54.8984C62.1769 53.4182 62.4825 52.1821 63.0891 51.2264C63.62 50.3865 64.4287 49.7909 65.4986 49.4558C64.4279 49.1203 63.6142 48.5299 63.0845 47.6914C62.4788 46.7339 62.1666 45.502 62.1647 44.0219L62.154 35.8515C62.1526 34.8174 61.864 34.0281 61.2752 33.4375C60.6864 32.8502 59.9987 32.5637 59.1795 32.5648L55.1849 32.57C54.6201 32.5707 54.1635 32.112 54.1628 31.5503L54.149 21.0208C54.1483 20.4559 54.607 19.9994 55.1685 19.9987L60.2071 19.9921C64.142 19.9869 67.1962 21.0665 69.2935 23.1981C71.3876 25.3298 72.4489 28.3613 72.4539 32.2069L72.462 38.3721C72.4641 39.9976 72.8853 41.1601 73.7087 41.8297C74.5554 42.5156 75.6297 42.8646 76.8983 42.8629L77.7409 42.8618C78.3058 42.8611 78.7623 43.3196 78.7631 43.8813L78.7776 54.9856C78.7783 55.5507 78.3196 56.0072 77.7581 56.0079L76.9155 56.009C75.6436 56.0107 74.5735 56.3623 73.7286 57.0505C72.9036 57.7224 72.4888 58.8858 72.4909 60.5113L72.499 66.6764C72.5039 70.4824 71.4475 73.5035 69.3621 75.6604C67.2735 77.8206 64.219 78.9181 60.2841 78.9233L60.2807 78.9233Z" fill="black" />
            <path d="M39.5008 20.0148L44.5392 20.0083C45.1043 20.0075 45.5606 20.4662 45.5613 21.0277L45.5751 31.5507C45.5758 32.1155 45.1173 32.5721 44.5556 32.5728L40.5613 32.578C39.7419 32.5791 39.0552 32.8676 38.4645 33.4564C37.8772 34.0453 37.5907 34.8353 37.592 35.8694L37.6027 44.0397C37.6046 45.5199 37.2991 46.756 36.6924 47.7117C36.1615 48.5516 35.3528 49.1472 34.2827 49.4823C35.3537 49.818 36.1673 50.4082 36.6971 51.2467C37.3028 52.2042 37.615 53.4361 37.6169 54.9162L37.6276 63.0868C37.6289 64.1209 37.9176 64.91 38.5064 65.5006C39.0952 66.0879 39.7827 66.3746 40.6021 66.3735L44.5964 66.3683C45.1615 66.3676 45.6181 66.8261 45.6188 67.3878L45.6325 77.9173C45.6333 78.4822 45.1746 78.9387 44.6129 78.9394L39.5745 78.946C35.6396 78.9512 32.5854 77.8715 30.4881 75.7399C28.3939 73.6083 27.3327 70.5768 27.3277 66.7312L27.3196 60.566C27.3175 58.9405 26.8963 57.7782 26.0728 57.1084C25.226 56.4225 24.1518 56.0737 22.8832 56.0754L22.0407 56.0765C21.4758 56.0772 21.0192 55.6185 21.0184 55.0568L21.0039 43.9525C21.0032 43.3876 21.4618 42.9311 22.0235 42.9304L22.8661 42.9293C24.138 42.9276 25.2079 42.5758 26.0529 41.8876C26.878 41.2159 27.2928 40.0523 27.2907 38.4268L27.2826 32.2619C27.2776 28.4557 28.3341 25.4346 30.4195 23.2777C32.508 21.1175 35.5625 20.02 39.4975 20.0148L39.5008 20.0148Z" fill="black" />
          </svg>
        </div>
        <div className="prompt-icon-pink">
          <svg viewBox="0 0 100 100"  xmlns="http://www.w3.org/2000/svg">
          <path d="M84.1772 0H15.8228C7.0841 0 0 7.0841 0 15.8228V84.1772C0 92.9159 7.0841 100 15.8228 100H84.1772C92.9159 100 100 92.9159 100 84.1772V15.8228C100 7.0841 92.9159 0 84.1772 0Z" fill="#FDADEE"></path>
          <path d="M43.4386 77.7849H55.8867V77.7962C56.7658 77.7962 57.4871 77.0806 57.4871 76.1958V62.7393L69.1405 69.4676C69.5125 69.676 69.9407 69.738 70.3576 69.6254C70.7747 69.5127 71.1184 69.2477 71.3325 68.8758L77.5593 58.0958C78.0044 57.3294 77.7397 56.349 76.9732 55.9038L65.3199 49.1754L76.9732 42.4471C77.7397 42.0019 77.999 41.0214 77.5593 40.2551L71.3325 29.4752C71.1184 29.1032 70.769 28.8382 70.3576 28.7256C69.9407 28.6129 69.5125 28.6692 69.1405 28.8834L57.4871 35.6116V22.1551C57.4871 21.276 56.7715 20.5547 55.8867 20.5547H43.4386C42.5597 20.5547 41.8384 21.2703 41.8384 22.1551V35.6116L30.1848 28.8834C29.4186 28.4439 28.438 28.703 27.9928 29.4695L21.7661 40.2494C21.3209 41.0159 21.5857 41.9962 22.3521 42.4414L34.0055 49.1699L22.3521 55.8982C21.5857 56.3433 21.3266 57.3239 21.7661 58.0901L27.9928 68.8703C28.438 69.6365 29.4186 69.8958 30.1848 69.4562L41.8384 62.7279V76.1846C41.8384 77.0638 42.554 77.7849 43.4386 77.7849Z" fill="black"></path>          </svg>
        </div>

        <div className="prompt-header">
          <h1 className="prompt-title">
            Bring Your Ideas to <span className='title-animate'>Life</span>
          </h1>
          <p className="prompt-subtitle">
            Describe your vision and we'll transform it into actionable requirements
          </p>
        </div>

        {error && (
          <div className="error-message">
            <svg className="error-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="prompt-form">
          <div className="form-group">
            <div className="input-wrapper">
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder=" "
              />
              <label htmlFor="email" className="input-label">
                Your Email Address
              </label>
              <div className="input-highlight"></div>
            </div>
          </div>

          <div className="form-group">
            <div className="textarea-wrapper">
              <textarea
                id="prompt"
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                className="form-textarea"
                placeholder=" "
                rows={6}
              />
              <label htmlFor="prompt" className="textarea-label">
                Project Description
              </label>
              <div className="textarea-highlight"></div>
              <div className="character-count">
                {prompt.length}/2000
              </div>
            </div>
          </div>

          <button
            type="submit"
            className="submit-button"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner"></span>
                Processing...
              </>
            ) : (
              <>
                <svg className="button-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z" clipRule="evenodd" />
                </svg>
                Generate Project Requirements
              </>
            )}
          </button>
        </form>

        <div className="prompt-footer">
          <p>We'll send the organized requirements to your email</p>
        </div>
      </div>
    </div>
  );
};

export default GeneratePrompt;
